import { createStore } from 'zustand';
import { devtools } from 'zustand/middleware';

export type SelectedBet = {
  betId: number;
  bookieCode: string;
};

export type SyncBet = {
  bestOddsBookmakers: string;
  betId: number;
};

export type MostPopularBetsState = {
  addSelectedBet: (bet: SelectedBet) => void;
  removeAllSelectedBets: () => void;
  removeSelectedBet: (id: number) => void;
  selectedBets: SelectedBet[];
  syncBetslip: (bets: SyncBet[], overwriteSelections?: boolean) => void;
};

export const createMostPopularBetsStore = () =>
  createStore<MostPopularBetsState>()(
    devtools(
      set => ({
        addSelectedBet: (bet: SelectedBet) => {
          set((state: { selectedBets?: SelectedBet[] }) => ({
            selectedBets: [...(state.selectedBets || []).filter(b => b.betId !== bet.betId), bet],
          }));
        },
        removeAllSelectedBets: () => {
          set({ selectedBets: [] });
        },
        removeSelectedBet: (id: number) => {
          set((state: { selectedBets?: SelectedBet[] }) => ({
            selectedBets: (state.selectedBets || []).filter(b => b.betId !== id),
          }));
        },
        selectedBets: [],
        syncBetslip: (bets: SyncBet[], overwriteSelections?: boolean) => {
          set((state: { selectedBets?: SelectedBet[] }) => {
            // overwrite existing selections
            if (overwriteSelections) {
              return {
                selectedBets: bets.map(b => ({
                  betId: b.betId,
                  bookieCode: b.bestOddsBookmakers.split(',')[0],
                })),
              };
            }

            // retain existing selections
            const selectedBets = state.selectedBets || [];
            return {
              selectedBets: [
                ...selectedBets,
                ...bets.reduce((a: SelectedBet[], b: SyncBet) => {
                  if (!selectedBets.find(({ betId }) => b.betId === betId)) {
                    a.push({
                      betId: b.betId,
                      bookieCode: b.bestOddsBookmakers.split(',')[0],
                    });
                  }
                  return a;
                }, []),
              ],
            };
          });
        },
      }),
      { enabled: !import.meta.env.PROD, name: 'MostPopularBetsStore' },
    ),
  );
